import { useMutation, useQueryClient } from '@tanstack/react-query';
import { z } from 'zod';
import { queryKeys } from '../client/query-client';
import { SessionResponse } from '../session/session';
/**
 * `POST /api/me/photo` — set or clear the caller's own portrait.
 *
 * The body carries a MEMBER-policy `assetId` uploaded through the two-step
 * media door (`useUploadAttachment`); `null` clears the current portrait. The
 * server answers the updated `SessionResponse` — the same shape
 * `GET /auth/session` returns — so the header redraws from `photoUrl` without
 * a second round trip. We push it straight into the session cache rather than
 * invalidating: an invalidation would flash the stale portrait on the way to
 * the fresh one.
 *
 * Refusals to surface: `MEDIA_REFERENCE_NOT_FOUND` (unknown or non-ready id)
 * and `MEDIA_ASSET_NOT_MEMBER` (an editorial library id — refused because a
 * library photograph presented as somebody's own claim would bypass the
 * derivative that strips EXIF).
 */
export const SetUserPhoto = z.object({
    photoAssetId: z.string().uuid().nullable(),
});
export function useSetMyPhoto(http) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (photoAssetId) => http.post('/me/photo', SetUserPhoto.parse({ photoAssetId }), {
            schema: SessionResponse,
        }),
        onSuccess: (session) => {
            queryClient.setQueryData(queryKeys.session, session);
        },
    });
}
//# sourceMappingURL=photo.js.map